<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-1 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Entity Configurations</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Seamlessly orchestrate and scale multi-cloud automation nodes and configuration schemas.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <div class="d-flex d-sm-inline-flex">
              <button type="button" class="btn btn-light entity-action-btn btn-sm rounded-small shadow-sm fw-semibold d-inline-flex align-items-center justify-content-center px-2 py-1 border-0 text-white text-nowrap" @click="open_create_modal">
                <i class="bi bi-plus-circle-fill me-2 text-white"></i>
                Create New Entity Type
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-2">
        <section class="row entity-config-top-metrics">
      <div
        v-for="metric in metrics"
        :key="metric.label"
        class="col-12 col-sm-6 mt-2 mt-sm-0"
      >
        <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="d-flex flex-column justify-content-start pt-1 ps-2">
              <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                {{ metric.label }}
              </span>
              <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
            </div>

            <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white" :class="`metric-icon-${metric.tone}`">
              <i class="bi" :class="metric.icon"></i>
            </div>
          </div>
        </article>
      </div>
        </section>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-grid-3x3-gap-fill"></i>
            </div>
            <div class="entity-section-title fw-bold fs-6">Active Entity Types</div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-funnel-fill"></i>
              <select
                v-model="status_filter"
                class="form-select form-select-sm rounded-small"
                aria-label="Filter entity configs"
              >
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-sort-down"></i>
              <select
                v-model="sort_option"
                class="form-select form-select-sm rounded-small"
                aria-label="Sort entity configs"
              >
                <option value="updated_desc">Newest Updated</option>
                <option value="updated_asc">Oldest Updated</option>
                <option value="name_asc">Name A-Z</option>
                <option value="name_desc">Name Z-A</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-4">Entity Type Name</div>
          <div class="col-lg-2">Status</div>
          <div class="col-lg-2">Version</div>
          <div class="col-lg-2">Summary of Bindings</div>
          <div class="col-lg-2"></div>
        </div>
      </div>

      <div v-if="inventory_loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading entity configurations...</span>
      </div>

      <div v-else-if="paginated_inventory.length" class="d-flex flex-column gap-2">
        <article
          v-for="item in paginated_inventory"
          :key="item.name"
          class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block col-10 col-lg-4 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center" :class="`entity-icon-${item.tone}`">
                <i class="bi" :class="item.icon"></i>
              </div>
              <div>
                <div class="entity-name fw-bold">{{ item.name }}</div>
                <div class="entity-updated text-secondary small">{{ item.updated }}</div>
              </div>
            </div>

            <div class="col-2 d-flex justify-content-end align-items-start d-lg-none">
              <button type="button" class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center" @click="open_entity_config(item)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>

            <div class="entity-status-block col-4 col-lg-2">
              <span class="entity-status-pill d-inline-flex align-items-center justify-content-center fw-bold text-uppercase" :class="item.status_class">
                {{ item.status }}
              </span>
            </div>

            <div class="entity-version col-4 col-lg-2 fw-bold">{{ item.version }}</div>

            <div class="entity-binding-block col-4 col-lg-2 d-flex flex-wrap align-items-center gap-2">
              <div class="entity-binding-icons d-flex align-items-center">
                <span
                  v-for="binding in item.binding_summary"
                  :key="`${item.id}-${binding.key}`"
                  class="entity-binding-icon rounded-circle d-inline-flex align-items-center justify-content-center"
                  :class="{ 'entity-binding-icon-inactive': !binding.active }"
                >
                  <i class="bi" :class="binding.icon"></i>
                </span>
              </div>
              <div class="text-secondary small">{{ item.bindings }}</div>
            </div>

            <div class="col-12 col-lg-2 d-flex justify-content-end align-items-center gap-2 pt-2">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="open_edit_modal(item)"
              >
                Edit
              </button>
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="is_project_scoped ? unassign_project_from_entity_type(item) : open_assign_modal(item)"
              >
                {{ is_project_scoped ? 'Unassign' : 'Assign' }}
              </button>
              <button type="button" class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center" @click="open_entity_config(item)">
                <i class="bi bi-chevron-right fs-6"></i>
              </button>
            </div>
          </div>
        </article>
      </div>

      <div
        v-if="!inventory_loading && paginated_inventory.length"
        class="d-flex flex-column gap-3 mt-3"
      >
        <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
          <div class="text-secondary small">
            Showing {{ current_page_start }} to {{ current_page_end }} of {{ current_backend_batch_count }} entries
          </div>
          <div v-if="current_chunk_total_pages > 1" class="d-flex align-items-center gap-2 flex-wrap">
            <button
              type="button"
              class="btn entity-panel-btn btn-sm rounded-small px-3 py-2"
              :disabled="current_chunk_page <= 1"
              @click="go_to_page(current_chunk_page - 1)"
            >
              Previous
            </button>
            <button
              v-for="page in visible_page_numbers"
              :key="`page-${page}`"
              type="button"
              class="btn btn-sm rounded-small px-3 py-2"
              :class="page === current_chunk_page ? 'btn-primary' : 'entity-panel-btn'"
              @click="go_to_page(page)"
            >
              {{ page }}
            </button>
            <button
              type="button"
              class="btn entity-panel-btn btn-sm rounded-small px-3 py-2"
              :disabled="current_chunk_page >= current_chunk_total_pages"
              @click="go_to_page(current_chunk_page + 1)"
            >
              Next
            </button>
          </div>
        </div>
        <div class="text-secondary small">
          Showing page {{ current_backend_page }} of {{ backend_total_pages }}
        </div>
      </div>

      <div v-if="!inventory_loading && !paginated_inventory.length" class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 p-lg-5 d-flex flex-column align-items-center justify-content-center text-center gap-3">
          <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-4">
            <i class="bi bi-inbox fs-1 opacity-75"></i>
          </div>
          <div>
            <p class="fw-bold text-x mb-1">
              {{ inventory.length ? 'No Matching Entity Configurations' : (is_project_scoped ? 'No Entity Configs Assigned' : 'No Entity Configurations Yet') }}
            </p>
            <p class="text-secondary text-xs mb-0">
              {{ inventory.length ? 'Try a different filter or sort selection.' : (is_project_scoped ? 'No entity configurations were assigned/binded to this project.' : 'Create your first entity type to start configuring and assigning projects.') }}
            </p>
          </div>
        </div>
      </div>

    </section>

    <button type="button" class="entity-floating-add rounded-4 shadow d-inline-flex align-items-center justify-content-center" @click="open_create_modal">
      <i class="bi bi-plus-lg"></i>
    </button>

    <teleport to="body">
      <div
        v-if="show_create_modal"
        class="modal fade show d-block"
        id="create_entity_type"
        tabindex="-1"
        aria-labelledby="create_entity_type_label"
        aria-modal="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs mb-0" id="create_entity_type_label">
                Create Entity Type
              </p>
              <button
                type="button"
                class="modal-btn-close btn-close"
                aria-label="Close"
                @click="close_create_modal"
              ></button>
            </div>

            <div class="modal-body">
              <div class="modal-form-group form-group mb-3">
                <label class="modal-form-label form-label text-xxs">
                  Entity Category:
                </label>
                <div class="position-relative">
                  <select
                    v-model="create_form.entity_type_category"
                    class="modal-form-control form-control text-xxs pe-5"
                  >
                    <option value="">Select category</option>
                    <option
                      v-for="category in entity_type_categories"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.entity_category_name }}
                    </option>
                  </select>
                  <i class="bi bi-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-secondary cursor-pointer dropdown-arrow"></i>
                </div>
              </div>

              <div class="modal-form-group form-group mb-3 secondary-color">
                <label for="entity_type_name" class="modal-form-label form-label text-xxs">
                  Entity Type Name:
                </label>
                <input
                  id="entity_type_name"
                  v-model="create_form.entity_type_name"
                  type="text"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  placeholder="Please enter an entity type name"
                />
              </div>

              <div class="modal-form-group form-group mb-3">
                <label for="entity_type_description" class="modal-form-label form-label text-xxs">
                  Entity Type Description (Optional):
                </label>
                <textarea
                  id="entity_type_description"
                  v-model="create_form.entity_type_description"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  rows="4"
                  placeholder="Please enter a description for the entity type"
                ></textarea>
              </div>
            </div>

            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                :disabled="creating_entity_type"
                @click="create_entity_type"
              >
                {{ creating_entity_type ? 'Creating...' : 'Save' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show_create_modal" class="modal-backdrop fade show"></div>
    </teleport>

    <teleport to="body">
      <div
        v-if="show_edit_modal"
        class="modal fade show d-block"
        id="edit_entity_type"
        tabindex="-1"
        aria-labelledby="edit_entity_type_label"
        aria-modal="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs mb-0" id="edit_entity_type_label">
                Edit Entity Type
              </p>
              <button
                type="button"
                class="modal-btn-close btn-close"
                aria-label="Close"
                @click="close_edit_modal"
              ></button>
            </div>

            <div class="modal-body">
              <div class="modal-form-group form-group mb-3 secondary-color">
                <label for="edit_entity_type_name" class="modal-form-label form-label text-xxs">
                  Entity Type Name:
                </label>
                <input
                  id="edit_entity_type_name"
                  v-model="edit_form.entity_type_name"
                  type="text"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  placeholder="Please enter an entity type name"
                />
              </div>

              <div class="modal-form-group form-group mb-3">
                <label for="edit_entity_type_description" class="modal-form-label form-label text-xxs">
                  Entity Type Description (Optional):
                </label>
                <textarea
                  id="edit_entity_type_description"
                  v-model="edit_form.entity_type_description"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  rows="4"
                  placeholder="Please enter a description for the entity type"
                ></textarea>
              </div>
            </div>

            <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                :disabled="updating_entity_type"
                @click="update_entity_type"
              >
                {{ updating_entity_type ? 'Saving...' : 'Save Changes' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show_edit_modal" class="modal-backdrop fade show"></div>
    </teleport>

    <teleport to="body">
      <div
        v-if="show_assign_modal"
        class="modal fade show d-block"
        id="assign_project"
        tabindex="-1"
        aria-labelledby="assign_project_label"
        aria-modal="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs mb-0" id="assign_project_label">
                Assign project <span v-if="assign_entity?.name" class="fw-normal">— {{ assign_entity.name }}</span>
              </p>
              <button
                type="button"
                class="modal-btn-close btn-close"
                aria-label="Close"
                @click="close_assign_modal"
              ></button>
            </div>

            <div class="modal-body mt-3">
              <div v-if="companies_loading || assign_bindings_loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                <span>Loading projects...</span>
              </div>

              <div v-else class="d-flex flex-column gap-2">
                <div
                  v-for="project in companies"
                  :key="project.id"
                  class="border rounded-3 p-2 d-flex align-items-center justify-content-between gap-2 shadow-sm"
                >
                  <div class="d-flex align-items-center gap-2 overflow-hidden">
                    <div
                      class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0 assign-project-avatar"
                    >
                      <span class="text-xxs">{{ project_short_label(project) }}</span>
                    </div>
                    <div class="overflow-hidden">
                      <div class="fw-semibold text-xs text-body-emphasis text-truncate">
                        {{ project_display_name(project) || `Project ${project.id}` }}
                      </div>
                    </div>
                  </div>

                  <div class="form-check form-switch m-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="is_project_selected(project.id)"
                      :disabled="is_project_toggle_loading(project.id)"
                      @change="on_project_toggle(project, $event)"
                    />
                  </div>
                </div>

                <div v-if="!companies.length" class="text-center text-secondary text-xs py-4">
                  No projects found.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show_assign_modal" class="modal-backdrop fade show"></div>
    </teleport>
  </div>
</div>
